import "./About.scss"

export default function About() {
  return (
    <h1 className="about">About</h1>
  )
}